"use client";

import React from "react";
import Link from "next/link";
import { v3 } from "@/lib/theme";
import { Button } from "@/components/ui/button";

import { ThemeToggle } from "@/components/ui/ThemeToggle";

export function V3Topbar() {
  return (
    <div style={{ padding: "20px 56px", display: "flex", alignItems: "center", gap: 40, borderBottom: `1px solid ${v3.line}`, background: "var(--background)", position: "sticky", top: 0, zIndex: 50 }}>
      <Link href="/" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none" }}>
        <div style={{ width: 22, height: 22, position: "relative" }}>
          <div style={{ position: "absolute", inset: 0, border: `1.5px solid ${v3.accent}`, borderRadius: 99 }} />
          <div style={{ position: "absolute", left: "50%", top: "50%", width: 2, height: 9, background: v3.accent, transform: "translate(-50%,-90%)" }} />
        </div>
        <div className="text-foreground" style={{ font: `500 17px ${v3.sans}`, letterSpacing: "-0.01em" }}>realpilot</div>
      </Link>
      
      <div style={{ flex: 1 }} />
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        <Link href="/login" style={{ textDecoration: "none" }}>
          <span className="hidden sm:inline text-muted-foreground hover:text-foreground transition-colors" style={{ font: `13px ${v3.sans}` }}>Anmelden</span>
        </Link>
        <Link href="/register" style={{ textDecoration: "none" }}>
          <Button>Cockpit starten</Button>
        </Link>
        <ThemeToggle />
      </div>
    </div>
  );
}
